/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import {
    getMasterCardRegisterObject,
    getTOCHMembershipArray,
    handleCheckMembershipExists,
} from '../helpers/toch-helpers';
import * as userAccountActions from '../../../sso/store/actions/user-account-actions';
import { isEmpty } from '../../../sso/components/utils/obj-utils';
import userService from '../../../../general/js/user/user-service';
import MastercardRegistration from '../mastercard-registration/MasterCardRegistration';
import TOCHModal from '../helpers/TOCHModal';
import { TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME, USER_STATE_VALID } from '../../../../general/js/user/constants';
import {
    MembershipTypes, addQueryParams, getParameterByName, redirectTo
} from '../../../../general/js/utils';
import { QueryConstants } from '../../../../general/js/utils/query-constants';
import { isNullOrUndefined } from '../../../../general/js/general-helpers';

class TOCHForceSignIn extends Component {
    constructor(...args) {
        super(...args);

        this.state = {
            isDataReceived: false,
            masterCardData: null,
            isModalOpen: false
        };

        this.handleUserLoginStatus = this.handleUserLoginStatus.bind(this);
        this.getUserData = this.getUserData.bind(this);
        this.callMasterCardUpgradeFormApi = this.callMasterCardUpgradeFormApi.bind(this);
        this.displayMasterCardUpgradeForm = this.displayMasterCardUpgradeForm.bind(this);
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
    }

    componentDidMount() {
        this.getUserData();
    }

    handleOnCloseModal = (value) => {
        const { masterCardData } = this.state;
        const options = getMasterCardRegisterObject(masterCardData);
        const MCRedirectUrl = options != null ? options.masterCardRegistrationSuccessCTALink : null;

        const redirectUrl = getParameterByName(QueryConstants.REDIRECT_URL);
        const link = !isEmpty(redirectUrl) ? redirectUrl + window.location.hash : window.location.href;
        const refreshLink = link != null ? link : MCRedirectUrl != null ? MCRedirectUrl.url : null;

        this.setState({ isModalOpen: value });

        if (refreshLink != null) {
            //window.location.replace(refreshLink);
        }
    }

    handleUserLoginStatus() {
        userService.setDataInLocalStorage(QueryConstants.REDIRECT_URL, window.location.pathname + encodeURIComponent(window.location.search));
        const { userAccountData, isUserNotSignedIn, isUserAccountDataLoadedSuccessful } = this.props;
        const {
            notOneClubPage, notSignInPage, overviewPage, isInEditMode
        } = this.props.options;

        const redirectUrlFromCookie = userService.getDataFromLocalStorage(QueryConstants.REDIRECT_URL);
        const redirectUrlFromCookieExistance = redirectUrlFromCookie !== null && redirectUrlFromCookie !== '' && redirectUrlFromCookie !== undefined;

        const dataLoadedSuccessful = !isUserNotSignedIn && isUserAccountDataLoadedSuccessful && !isEmpty(userAccountData);
        const membershipArray = getTOCHMembershipArray(userAccountData['custom:Membership']);
        const isOneClub = handleCheckMembershipExists(membershipArray, MembershipTypes.OneClub);
        const windowUrl = decodeURI(window.location.href.toLocaleLowerCase()).replace(/ /g, '-');

        if (isInEditMode === undefined || isInEditMode === false) {
            if (isUserNotSignedIn) {
                userService.removeDataFromLocalStorage(TOCH_USER_ADDRESS_BOOK_LOCALSTORAGE_NAME);
                userService.removeDataFromLocalStorage(USER_STATE_VALID);
                const redirectUrl = (overviewPage === undefined || overviewPage === null) ? '/' : overviewPage.url;

                const redirect = redirectUrlFromCookieExistance ? redirectUrlFromCookie : redirectUrl;
                redirectTo(addQueryParams(notSignInPage.url, [
                    {
                        key: QueryConstants.REDIRECT_TO,
                        value: redirect
                    }
                ]));
            }
            if (isOneClub && windowUrl.includes(notOneClubPage.url)) {
                const redirectUrl = (overviewPage === undefined || overviewPage === null) ? '/' : overviewPage.url;
                redirectTo(redirectUrl);
                return null;
            }
        }
        const oneClubBody = document.getElementById('randa-one-club-body');
        if (dataLoadedSuccessful) {
            userService.setTOCHUserMembershipsInLocalStorage(JSON.stringify(userAccountData['custom:Membership']));

            if (isOneClub) {
                if (!isNullOrUndefined(oneClubBody)) {
                    oneClubBody.style.removeProperty('visibility');
                }

                userService.removeDataFromLocalStorage(QueryConstants.REDIRECT_URL);
            }
        } else if (isInEditMode) {
            if (!isNullOrUndefined(oneClubBody)) {
                oneClubBody.style.removeProperty('visibility');
            }
        }

        return null;
    }

    callMasterCardUpgradeFormApi() {
        const { masterCardRegistrationEndpoint } = this.props.options;

        axios.post(masterCardRegistrationEndpoint).then((response) => {
            this.setState({ isDataReceived: true, masterCardData: response.data, isModalOpen: true });
        }).catch((error) => {
            this.setState({ formHasErrors: true });
            console.error(error);
        });
    }

    displayMasterCardUpgradeForm() {
        const { masterCardData, isModalOpen } = this.state;

        const options = getMasterCardRegisterObject(masterCardData);

        return (
            masterCardData.item != null && isModalOpen && masterCardData.openPopup ?
                <div>
                    <div className="overlay is-visible" id="overlay" />
                    <TOCHModal
                        handleOnClose={this.handleOnCloseModal}>
                        <MastercardRegistration
                            options={options}
                        ></MastercardRegistration>
                    </TOCHModal>
                </div> :
                null
        );
    }

    getUserData() {
        const { actions } = this.props;
        const { getUserAccountDataCallBackURL } = this.props.options;

        actions.getUserAccountData(getUserAccountDataCallBackURL);
    }

    render() {
        const { isDataReceived } = this.state;

        return (
            !isDataReceived ?
                this.handleUserLoginStatus() :
                this.displayMasterCardUpgradeForm()
        );
    }
}

function mapStateToProps(state) {
    return {
        isUserNotSignedIn: state.userAccount.isUserNotSignedIn,
        isUserAccountDataLoadedSuccessful: state.userAccount.isUserAccountDataLoadedSuccessful,
        userAccountData: state.userAccount.userAccountData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getUserAccountData: bindActionCreators(userAccountActions.getUserAccountData, dispatch),
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TOCHForceSignIn);
